import styled from 'styled-components'
import tw from 'twin.macro'

export const Main = styled.div`
  ${tw`px-insetX ta-max-width grid lg:grid-flow-col-dense justify-start	gap-8`};
`

export const Filter = styled.div`
  ${tw`lg:pr-8`};
  border-right: solid 1px var(--color-grey);
`

export const TrunkShows = styled.div``

export const Columns = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8`};
`

export const Column = styled.div``

export const Placeholder = styled.div``
